import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
// Swap out any of these for Sarasota-specific shots
import heroImg   from '../images/tampa3.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image121.webp';
import slideImg2 from '../images/image117.webp';
import slideImg3 from '../images/image50.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const lutzConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Lutz Tree Service | Sam\'s Tree Service',
  metaDescription: 'Expert tree trimming and removal in Lutz, FL. Sam\'s Tree Service handles dangerous trees safely and professionally.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_lutz',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Lutz',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Lutz Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we handle the tree work that keeps 
     properties safe across <strong>Lutz</strong>. This community spans the border 
     of Hillsborough and Pasco County and features a mix of large wooded lots, 
     lakefront properties, and established subdivisions all with trees that grow 
     large and fast in Florida's climate. When storm season hits, those trees need 
     to be managed before they become liabilities.`,

    `We specialize in <strong>large lot and residential tree removal and trimming</strong> 
     including massive oak removals, lakefront tree work, storm cleanup on acreage 
     properties, and precision trimming near homes and outbuildings. We bring the 
     equipment for big jobs and the care for detailed ones.`,

    `<strong>Sam's Tree Service</strong> delivers dependable, affordable tree care 
     throughout <strong>Lutz</strong> and the surrounding 
     <strong>North Hillsborough and South Pasco</strong> area keeping your 
     property protected and your trees healthy all year long.`,
  ],
  ctaLabel: 'Get a Free Estimate!',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Lutz, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_Lutz = () => <LocationPage config={lutzConfig} />;
export default Services_Lutz;
